import axios from 'axios';

import api from '../utils/api';

// service
import { logError } from '@zg-rentals/log-error';

const UserActions = {
  addReferral({ code }) {
    return (dispatch) =>
      dispatch(api.users.referrals.add({ code }))
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success) {
            return response.response;
          }

          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.addReferral',
          });

          return Promise.reject(errorRMWModel);
        });
  },
  getUserAddress() {
    return (dispatch) =>
      dispatch(api.users.getUserAddress())
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success) {
            return response.response;
          }

          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.getUserAddress',
          });

          return Promise.reject(errorRMWModel);
        });
  },
  setUserAddress({ street, unit, city, state, zip }) {
    return (dispatch) =>
      dispatch(api.users.setUserAddress(street, unit, city, state, zip))
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success) {
            return response.response;
          }

          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.setUserAddress',
          });

          return Promise.reject(errorRMWModel);
        });
  },

  // HotPads
  logoutUser(hostname) {
    return () =>
      new Promise((resolve, reject) => {
        const options = {
          method: 'delete',
          url: `${hostname}/node/api/cookies?trace=true`,
        };

        axios(options)
          .then(() => {
            // Success will redirect user to hotpads.com
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
  },

  insertAction(params) {
    return (dispatch) =>
      dispatch(api.users.intention.insertAction(params))
        .then((response = {}) => {
          if (response && response.success) {
            return { success: true };
          }
          return { success: false };
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.insertAction',
          });
        });
  },

  reportSpam(params) {
    return (dispatch) =>
      dispatch(api.users.reportSpam(params))
        .then((response = {}) => {
          if (response && response.success) {
            return { success: true };
          }
          return { success: false };
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.reportSpam',
          });
        });
  },

  trackEvent(params) {
    return (dispatch) =>
      dispatch(api.users.trackEvent(params))
        .then((response = {}) => ({ success: response && response.success }))
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.trackEvent',
          });
        });
  },

  saveUserProfile(params) {
    return (dispatch) =>
      dispatch(api.users.profile.saveUserInfo(params))
        .then((response = {}) => {
          if (response.success === false) {
            return Promise.reject(response.error);
          }
          return response;
        })
        .catch((err) => Promise.reject(err));
  },

  setName(params) {
    return (dispatch) =>
      dispatch(api.users.profile.setName(params))
        .then((response = {}) => {
          if (response.success === false) {
            return Promise.reject(response.error);
          }
          return response;
        })
        .catch((err) => Promise.reject(err));
  },
};

export default UserActions;
